import { useState } from 'react';
import YouTube, { YouTubeEvent } from 'react-youtube';
import { connect, WithStore, MapStateToProps, MapDispatchToProps } from '../../redux/services/Imports';
import './YoutubeBlock.scss';
import './YoutubeBlock-media.scss';
import { Props } from './interfaces';
import Button from '../Button/Button';
import {content} from "../../services/content";

const YoutubeBlock = ({
  title,
  video,
  poster,
  buttonLink,
  height = '600px',
  fullWidth = false,
  fullText,
  widthWindow,
}: Props) => {
  const [showPreview, setShowPreview] = useState(true);
  const [eventYoutube, setEventYoutube] = useState<YouTubeEvent<any>>();

  const onReady = (event: YouTubeEvent<any>) => {
    setEventYoutube(event);
  };

  const onPause = (event: any) => {
    event.target.pauseVideo();
  };

  const onPlay = () => {
    eventYoutube?.target.playVideo();
    setShowPreview(false);
  };

  const onEnd = () => {
    setShowPreview(true);
  };

  const heightContentFull = fullWidth
    ? widthWindow > 720
      ? `calc(100vh - 132px)`
      : `calc(100dvh - 96px)`
    : height;
  const heightContainer = fullWidth ? (widthWindow > 720 ? `100vh` : `calc(100dvh - 56px)`) : 'auto';

  const opts = {
    height: '100%',
    width: '100%',
    playerVars: {
      autoplay: 0,
      controls: 1,
    },
  };

  return (
    <>
      <div
        className={`block-youtube${showPreview ? ' block-youtube_dark' : ''}${
          fullWidth ? ' block-youtube_full-width' : ''
        }`}
      >
        {title ? <h2 className="block-youtube__title">{title}</h2> : null}

        <div className="block-youtube__container" style={{ height: heightContainer }}>
          <YouTube
            videoId={video}
            opts={opts}
            className="block-youtube__video"
            onReady={onReady}
            onPause={onPause}
            onEnd={onEnd}
            style={{
              display: showPreview ? 'none' : 'block',
              height: fullWidth ? (widthWindow > 720 ? `100vh` : `calc(100dvh - 56px)`) : '100%',
            }}
          />

          {showPreview ? (
            <div
              className="block-youtube__video"
              style={{ backgroundImage: `url(${poster})` }}
              onClick={onPlay}
            ></div>
          ) : null}

          {showPreview ? (
            <div className="block-youtube__play-block">
              {fullText ? <h1 dangerouslySetInnerHTML={{ __html: fullText }}></h1> : null}
              <div className="block-youtube__play" />
            </div>
          ) : null}

          {buttonLink ? (
            <div className="block-youtube__button">
              <Button
                text={content.youtubeBlock.watchFull}
                type="border"
                link={buttonLink}
                linkOut
                size={widthWindow > 720 ? 'L' : 'M'}
                widthAll={widthWindow < 720}
              />
            </div>
          ) : null}
        </div>
      </div>

      {fullWidth ? (
        <div className="block-youtube__height-full" style={{ height: heightContentFull }} />
      ) : null}
    </>
  );
};

export default WithStore()(connect(MapStateToProps, MapDispatchToProps)(YoutubeBlock));
